enum DataExportSourceType {
    ExternalField = 1,
    Custom = 2,
    LinkToSource = 3
}

export default DataExportSourceType;